/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// List of 6 qty items by Vairable ID (not product ID)
window.minSixVariantIds = ["45405413933340", "50782267703580"];